export const delay = (time) => new Promise((resolve) => setTimeout(resolve, time));
//# sourceMappingURL=utils.js.map